
(() => {
	const initViewer = (viewer) => {
		if (!viewer || viewer.dataset.msReady === 'true') return;
		viewer.dataset.msReady = 'true';

		const section = viewer.closest('.shopify-section') || viewer.parentElement;
		const productSection = viewer.closest('section[id^="MainProduct-"]');
		if (!productSection) return;

		const sectionId = productSection.id.replace('MainProduct-', '');
		const modal = document.getElementById('ProductModal-' + sectionId);
		if (!modal) return;

		const imageEl = viewer.querySelector('[data-ms-image]');
		const counterEl = viewer.querySelector('[data-ms-counter]');
		const mobileCounterEl = viewer.querySelector('[data-ms-mobile-counter]');
		const closeButton = viewer.querySelector('[data-ms-close]');
		const prevButton = viewer.querySelector('[data-ms-prev]');
		const nextButton = viewer.querySelector('[data-ms-next]');
		const addButton = viewer.querySelector('[data-ms-add]');
		const buyButton = viewer.querySelector('[data-ms-buy]');

		let currentIndex = 0;
		let images = [];
		let lastTrigger = null;

		const collectImages = () => {
			const seen = new Set();
			images = Array.from(modal.querySelectorAll('img[data-media-id]'))
				.map((img) => ({
					id: String(img.dataset.mediaId || ''),
					src: img.currentSrc || img.src,
					srcset: img.srcset || '',
					alt: img.alt || viewer.dataset.productTitle || 'Product image'
				}))
				.filter((item) => {
					if (!item.id || !item.src || seen.has(item.id)) return false;
					seen.add(item.id);
					return true;
				});
		};

		const bestSource = (item) => {
			if (!item.srcset) return item.src;
			const parts = item.srcset.split(',').map((entry) => entry.trim()).filter(Boolean);
			if (!parts.length) return item.src;
			const last = parts[parts.length - 1].split(' ')[0];
			return last || item.src;
		};

		const render = () => {
			if (!images.length) return;
			const item = images[currentIndex];
			imageEl.src = bestSource(item);
			imageEl.alt = item.alt;
			counterEl.textContent = (currentIndex + 1) + ' / ' + images.length;
			if (mobileCounterEl) mobileCounterEl.textContent = (currentIndex + 1) + ' / ' + images.length;
			prevButton.hidden = images.length < 2;
			nextButton.hidden = images.length < 2;
		};

		const open = (mediaId, trigger) => {
			collectImages();
			if (!images.length) return;
			lastTrigger = trigger || null;
			const found = images.findIndex((item) => item.id === String(mediaId || ''));
			currentIndex = found >= 0 ? found : 0;
			render();
			viewer.hidden = false;
			document.body.classList.add('ms-product-viewer-open');
			closeButton.focus({ preventScroll: true });
		};

		const close = () => {
			viewer.hidden = true;
			document.body.classList.remove('ms-product-viewer-open');
			imageEl.removeAttribute('src');
			if (lastTrigger) lastTrigger.focus({ preventScroll: true });
		};

		const go = (step) => {
			if (!images.length) return;
			currentIndex = (currentIndex + step + images.length) % images.length;
			render();
		};

		productSection.addEventListener('click', (event) => {
			const opener = event.target.closest('.product__modal-opener');
			if (!opener) return;

			const toggle = opener.querySelector('.product__media-toggle');
			const mediaId = toggle?.dataset.mediaId
				|| opener.closest('[data-media-id]')?.dataset.mediaId?.split('-').pop()
				|| '';

			if (!mediaId) return;

			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
			open(mediaId, toggle || opener);
		}, true);

		closeButton.addEventListener('click', close);
		prevButton.addEventListener('click', () => go(-1));
		nextButton.addEventListener('click', () => go(1));

		viewer.addEventListener('click', (event) => {
			if (event.target === viewer) {
				close();
				return;
			}
			if (event.target.classList.contains('ms-product-viewer__image-wrap')) {
				go(1);
			}
		});

		const blockImageGrab = (event) => {
			event.preventDefault();
			event.stopPropagation();
		};

		viewer.addEventListener('contextmenu', blockImageGrab);
		viewer.addEventListener('dragstart', blockImageGrab);
		productSection.addEventListener('contextmenu', (event) => {
			if (event.target.closest('.product__media, .product__modal-opener')) {
				event.preventDefault();
			}
		});

		document.addEventListener('keydown', (event) => {
			if (viewer.hidden) return;
			if (event.key === 'Escape') close();
			if (event.key === 'ArrowLeft') go(-1);
			if (event.key === 'ArrowRight') go(1);
		});

		const getProductForm = () => productSection.querySelector('product-form form[action*="/cart/add"], product-form form');
		const getVariantId = () => {
			const form = getProductForm();
			return form?.querySelector('[name="id"]')?.value || '';
		};

		addButton?.addEventListener('click', () => {
			const form = getProductForm();
			if (!form) return;
			close();
			if (typeof form.requestSubmit === 'function') {
				form.requestSubmit();
			} else {
				form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
			}
		});

		buyButton?.addEventListener('click', async () => {
			const variantId = getVariantId();
			if (!variantId) return;

			const originalText = buyButton.textContent;
			buyButton.disabled = true;
			buyButton.textContent = 'LOADING…';

			try {
				const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json'
					},
					body: JSON.stringify({
						items: [{ id: Number(variantId), quantity: 1 }]
					})
				});

				if (!response.ok) {
					const error = await response.json().catch(() => ({}));
					throw new Error(error.description || error.message || 'Unable to add item');
				}

				window.location.assign(window.routes?.root_url ? window.routes.root_url + 'checkout' : '/checkout');
			} catch (error) {
				console.error('[Maison Saucisse viewer]', error);
				buyButton.disabled = false;
				buyButton.textContent = originalText;
				window.alert(error.message || 'This item could not be added to checkout.');
			}
		});

		const imageWrap = viewer.querySelector('.ms-product-viewer__image-wrap');
		let touchStartX = null;
		let touchStartY = null;

		imageWrap?.addEventListener('touchstart', (event) => {
			touchStartX = event.touches?.[0]?.clientX ?? null;
			touchStartY = event.touches?.[0]?.clientY ?? null;
		}, { passive: true });

		imageWrap?.addEventListener('touchend', (event) => {
			if (touchStartX === null || touchStartY === null) return;
			const endX = event.changedTouches?.[0]?.clientX ?? touchStartX;
			const endY = event.changedTouches?.[0]?.clientY ?? touchStartY;
			const deltaX = endX - touchStartX;
			const deltaY = endY - touchStartY;
			touchStartX = null;
			touchStartY = null;

			if (Math.abs(deltaX) >= 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
				go(deltaX > 0 ? -1 : 1);
			}
		}, { passive: true });
	};

	const initAll = () => document.querySelectorAll('[data-ms-product-viewer]').forEach(initViewer);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', initAll);
})();
